export default __webpack_public_path__ + "static/mobile-apps-image-2-58fe1c69c5c84ad71d68821443294438.jpg";